import { getTodayDd } from 'helpers/dates';
import {
    DeviceLastPrediction,
    DeviceLastReading,
    DevicePrediction,
} from 'types';

/**
 * Returns an object mapping device prediction to the dd (i.e., formatted date) value for each prediction.
 *
 * @export
 * @see src/helpers/dates.ts#getTodayDd
 */
export function mapPredictionsToDdValue(predictions: DevicePrediction[]): {
    [dd: number | string]: DevicePrediction;
} {
    const ddMap: { [dd: number | string]: DevicePrediction } = {};

    predictions.forEach((prediction: DevicePrediction) => {
        ddMap[prediction.dd] = prediction;
    });

    return ddMap;
}

/** Returns an estimated tank level based on the most recent prediction, if available, otherwise returns the value of the last tank reading. */
export function getEstimatedTankLevel(
    lastReading: DeviceLastReading | undefined | null,
    lastPrediction: DeviceLastPrediction
): number {
    let estimatedTankLevel = 0;

    if (lastReading) {
        estimatedTankLevel = lastReading?.tank || 0;
    }

    if (lastPrediction?.predictions) {
        const predictionsMap: { [dd: number | string]: DevicePrediction } =
            mapPredictionsToDdValue(lastPrediction.predictions);

        const dd = parseInt(getTodayDd());

        // If there is a tank level prediction for today, use that value.
        if (predictionsMap[dd]) {
            const predictionBasedLevel =
                predictionsMap[dd]?.tank || predictionsMap[dd]?.tankCAvg7;
            if (typeof predictionBasedLevel === 'string')
                estimatedTankLevel = parseFloat(predictionBasedLevel);
            else estimatedTankLevel = predictionBasedLevel;
        }
    }

    return estimatedTankLevel;
}
